// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import type { useI18n } from "@/i18n"

type TFn = ReturnType<typeof useI18n>["t"]

/**
 * The served unit, localised only where the wire value is not a printable unit.
 *
 * Canonical units are `g`, `ml` and `count` (services/catalog). `g` and `ml`
 * print as-is; `count` is an INTERNAL word that was leaking to the user — the
 * Kitchen's quantity column, the Shop row's required/pack/leftover cells and
 * both unit pickers all showed a German screen the English word "count". It
 * prints as pcs / Stk. instead. This label never touches the NUMBER: the Kitchen
 * and the Shop show the served quantity as it is (half an onion left is half an
 * onion). Only a RECIPE line rounds a counted amount for display — see
 * lib/ingredientQuantity.ts.
 *
 * The web twin of `mobile/src/lib/units.ts` — same key, same answer, so the two
 * clients cannot drift (T21 propagation, 2026-09-10).
 */
export const unitLabel = (unit: string, t: TFn): string =>
  unit === "count" ? t("views.pantry.unitCount") : unit
